import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import enUSJson from "./translations/enUS.json";
import esESJson from "./translations/esES.json";
import ptBRJson from "./translations/ptBR.json";

i18n.use(initReactI18next).init({
	fallbackLng: "ptBR",
	interpolation: {
		escapeValue: false,
	},
	resources: {
		enUS: enUSJson,
		ptBR: ptBRJson,
		esES: esESJson,
	},
});

export default i18n;
